/* import __COLOCATED_TEMPLATE__ from './verify-project-digest-modal.hbs'; */
import Component from '@ember/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';
import { closeModal } from "sh-www/utils/modal-controls";

class VerifyProjectDigestModalComponent extends Component {
  tagName = '';

  @service('error-tracker')
  errorTracker;

  description = '';

  get isVerifying() {
    return this.handleVerifyProject.isRunning;
  }

  @task
  *handleVerifyProject() {
    const { projectDigest } = this.model;

    try {
      if (this.description) {
        yield this.model.saveAdminNote.perform(projectDigest, this.description);
      }

      yield this.model.verifyTask.perform(projectDigest);
    } catch (e) {
      this.errorTracker.error(e, this, `error verifying project digest "${projectDigest.title}"`);
    }

    this.set('description', '');

    closeModal(this);
  }

  /**
   * @param {String} field The name of the property.
   * @param {String} value The value of the property.
   */
  @action
  handleInput(field, value) {
    this.set(field, value);
  }

  @action
  handleDismiss() {
    closeModal(this);
  }
}

export default VerifyProjectDigestModalComponent;
